<template>

    <b-card :title="place.Text" class="m-20-0">

        <question-list v-model="questions"
                       :options="questionList"
                       :sub-questions="subQuestions"
                       :apiVersion="apiVersion"/>

        <b-row class="mt-20">
            <b-col cols="3" class="p-0">
                <b-button block 
                          class="draggable-button green" 
                          @click="addQuestion" >
                    Добавить вопрос
                </b-button>  
            </b-col>
        </b-row>
    </b-card>
    
</template>

<script>

import QuestionList from '@/components/admin/blocks/QuestionList'

export default {
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        value: [Object, Array],
        options: {
            type: Object,
            default: null
        },
        place: {
            type: Object,
            default: { Id: 1, Text: 'Начало аудита' }
        },
        apiVersion: {
            type: String,
            default: ""
        }
    },
    computed:{
        questionList: function() {
            return this.options.ParentQuestions.filter(e => e.Place == this.place.Id);
        },
        questions: {
            get: function() {
                return this.value;
            },
            set: function(value) {
                this.$emit('update', value);
            }
        }
    },
    data: function() {
        return {            
            subQuestions: this.options.SubQuestions
        }
    },
    methods: {
        addQuestion: function () {
            this.value.push({ Question: null, SubQuestions: [ ] });
            this.$emit('update', this.value);
        },
    },
    components: {
        QuestionList
    }
}
</script>